"use client";
import { signInWithApple } from '@/lib/authActions';
import React from "react";
import { FaApple } from "react-icons/fa";

const SignInWithAppleButton = () => {
  return (
    <button
      type="button"
      className="w-full flex items-center py-3 px-4 rounded-full bg-white text-gray-700 font-medium hover:bg-gray-100 transition-all border border-gray-300 shadow-sm"
      onClick={() => {
        signInWithApple();
      }}
    >
      <FaApple className="w-6 h-6 text-primary" />
      <span className="flex-grow text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-gradient-from to-primary-gradient-to">Sign in with Apple</span>
    </button>
  );
};

export default SignInWithAppleButton;